import { render, staticRenderFns } from "./TagEditor.vue?vue&type=template&id=5961c350"
import script from "./TagEditor.vue?vue&type=script&lang=js"
export * from "./TagEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5961c350')) {
      api.createRecord('5961c350', component.options)
    } else {
      api.reload('5961c350', component.options)
    }
    module.hot.accept("./TagEditor.vue?vue&type=template&id=5961c350", function () {
      api.rerender('5961c350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/entityTags/TagEditor.vue"
export default component.exports